import { AmphoraLogisticsTemplateLocale } from "schema"

const PRIMARY_LOGISTICS_LOCALE_BY_SUBTAG: Readonly<Record<string, AmphoraLogisticsTemplateLocale>> =
  {
    en: "en",
    es: "es",
    ca: "ca",
    pt: "pt_PT",
    it: "it",
    fr: "fr",
    de: "de",
  }

export const ORDERED_PRIMARY_LOGISTICS_LOCALES = Object.values(
  PRIMARY_LOGISTICS_LOCALE_BY_SUBTAG,
) as AmphoraLogisticsTemplateLocale[]

export function guessDefaultLogisticsLocales(
  i18nLanguage: string,
): AmphoraLogisticsTemplateLocale[] {
  const short = i18nLanguage.split("-")[0]?.toLowerCase() ?? "en"
  return [PRIMARY_LOGISTICS_LOCALE_BY_SUBTAG[short] ?? "en"]
}
